import styled from 'styled-components';

// KVKK talep durumu rozeti — self-servis (KVKK Taleplerim) ve İK (KVKK Talepleri) liste
// hücreleri ile ayrıntı gövdesi aynı renkleri kullanır.
// open = sarı, in_review = mavi, completed = yeşil, rejected = kırmızı.
const COLORS = {
  open: '#ca8a04',
  in_review: '#0291EF',
  completed: '#16a34a',
  rejected: '#ef4444',
};

const colorOf = (status) => COLORS[status] || COLORS.open;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  background: ${({ $status }) => `${colorOf($status)}15`};
  color: ${({ $status }) => colorOf($status)};
`;

export default StatusBadge;
